module.exports = __webpack_public_path__ + "static/media/equipment-type-report.397f6ecc.svg";